import React from 'react'
import clsx from 'clsx'
import { ArrowLeft } from 'iconsax-react'

import BaseModal from '../../../../molecules/ChatModals/BaseModal2'
import Button from '../../../../atoms/Button2'
import FilterModal from '../FilterModal'

import { ITEMS, ITEM_TYPES } from '../FilterMenu'

import useStyles from './styles'

//Modal only shows on mobile
interface MobileFilterModalProps {
  onClose: () => void
}
const MobileFilterModal: React.FC<MobileFilterModalProps> = ({ onClose }) => {
  const [selected, setSelected] = React.useState([])
  const [modalOpen, setModalOpen] = React.useState(false)

  const hasSelections = React.useMemo(
    () => selected.length > 0,
    [selected.length]
  )

  const handleCloseModal = React.useCallback(e => {
    e.stopPropagation()
    setModalOpen(false)
  }, [])

  const handleSave = React.useCallback(
    e => {
      onClose()
    },
    [onClose]
  )

  const handleSelect = React.useCallback((itemID, typeInfo) => {
    setSelected(old => {
      // Remove from selected
      if (old.includes(itemID)) {
        return old.filter(id => id !== itemID)
      }

      // Allows multiple of this type
      if (typeInfo.multi) {
        return [...old, itemID]
      }

      // Remove others of this type and then add it
      const type = itemID.split('-')[0]
      const typeRemoved = old.filter(id => id.split('-')[0] !== type)
      return [...typeRemoved, itemID]
    })
  }, [])

  const classes = useStyles()

  return (
    <React.Fragment>
      <BaseModal
        open
        //@ts-ignore
        title={
          <div className={classes.titleRow}>
            <ArrowLeft className={classes.returnIcon} onClick={onClose} />
            Filter
            {hasSelections && (
              <label onClick={() => setSelected([])} className={classes.reset}>
                Reset
              </label>
            )}
          </div>
        }
        onClose={onClose}
        showTitleOnMobile
        hideTitle={false}
        showX={false}
        PaperProps2={{
          style: {
            padding: '30px 16px 30px 16px',
            border: '1px solid #C6C6C6',
            borderRadius: '4px',
            width: '100%',
            maxWidth: 'unset',
            height: '100svh',
            maxHeight: 'unset',
            minHeight: 'auto'
          }
        }}
        classes={{ title: classes.modalTitle, close: classes.modalClose }}
        style={{ marginBottom: 66 }}
      >
        <div className={classes.sections}>
          {Object.entries(ITEM_TYPES).map(([type, typeInfo]) => (
            <div key={type} className={classes.section}>
              <div className={classes.sectionTitle}>{type}</div>

              <div className={classes.sectionContent}>
                {ITEMS.filter(item => item.type === type).map(item => (
                  <div
                    key={item.id}
                    onClick={() => handleSelect(item.id, typeInfo)}
                    className={clsx(
                      classes.item,
                      selected.includes(item.id) && classes.itemSelected
                    )}
                  >
                    {item.content}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className={classes.spacer}></div>

        {hasSelections && (
          <div className={classes.buttons}>
            <Button onClick={onClose} className={classes.button}>
              Show 0 Results
            </Button>

            <Button
              onClick={() => setModalOpen(true)}
              className={clsx(classes.button, classes.buttonInvert)}
            >
              Save and Show Results
            </Button>
          </div>
        )}
      </BaseModal>
      {modalOpen && (
        <FilterModal
          selected={selected}
          onClose={handleCloseModal}
          onSave={handleSave}
        />
      )}
    </React.Fragment>
  )
}

export default MobileFilterModal
